/**
 * Fixed English display names for tracking, aria-labels, and plan details.
 * Do not use i18n for these to keep analytics and a11y strings consistent.
 */
export const PLAN_DISPLAY_NAME = 'Zoom Virtual Agent Receptionist';
export const PLAN_DISPLAY_NAME_FREE_TRIAL = 'Zoom Virtual Agent Receptionist Free Trial';

export const PLAN_DETAIL_FEATURE_KEYS = [
  { title: 'billing.pbx.zp_aic.plan_details.feature_1_title', desc: 'billing.pbx.zp_aic.plan_details.feature_1_desc' },
  { title: 'billing.pbx.zp_aic.plan_details.feature_2_title', desc: 'billing.pbx.zp_aic.plan_details.feature_2_desc' },
  { title: 'billing.pbx.zp_aic.plan_details.feature_3_title', desc: 'billing.pbx.zp_aic.plan_details.feature_3_desc' },
  { title: 'billing.pbx.zp_aic.plan_details.feature_4_title', desc: 'billing.pbx.zp_aic.plan_details.feature_4_desc' },
];
